export const getCreateBark = () => {
    return Bark.createBark = Bark.createBark || {};
}
